import { render, staticRenderFns } from "./CosmeticTagEdit.vue?vue&type=template&id=6112c7e6&scoped=true"
import script from "./CosmeticTagEdit.vue?vue&type=script&lang=js"
export * from "./CosmeticTagEdit.vue?vue&type=script&lang=js"
import style0 from "./CosmeticTagEdit.vue?vue&type=style&index=0&id=6112c7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6112c7e6",
  null
  
)

export default component.exports